// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withRouter } from 'next/router';
import getConfig from 'next/config';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';

import { Head } from 'shared/page/Head';
import { Main } from 'shared/page/Main';

import { wrapper } from '@/store/store';
import { populateObjectSsr } from '@/ducks/object/objectActions';
import { populateProfile } from '@/ducks/profile/profileActions';
import { buildCommonProps } from '@/server/data/';
import { imageDataToMetaTags } from '@/lib/helpers/imageDataToMetaTags';
import { truncateWithEllipsis } from '@/lib/helpers/strings';

import { FhhState, ServerSideProps } from '@/interfaces';
import { ObjectPage } from '@/scenes/objectPage/ObjectPage';

const csrfKey = 'dfg87987fsghklrjytk9r0et8lksdfgjklcvjb9dfg3345w3';

const {
    publicRuntimeConfig: { broadcastUrl },
} = getConfig();

const Ad = (props) => {
    const objectData = useSelector((state: FhhState) => state.objectData);
    const imageMetaTags = imageDataToMetaTags(objectData.images?.[0]);
    const truncatedDescription = truncateWithEllipsis(objectData.description, 200);
    const podlets = JSON.parse(props.podlets);

    return (
        <>
            <Head
                title={`${objectData.heading} | FINN reise`}
                description={truncatedDescription}
                canonical={`https://www.finn.no/reise/feriehus-hytteutleie/ad.html?finnkode=${objectData.adId}`}
                imageUrl={imageMetaTags ? imageMetaTags.og.url : undefined}
                podlets={podlets}>
                {imageMetaTags !== null && (
                    <>
                        <meta property="og:image:alt" content={imageMetaTags.og.description} />
                        <meta name="twitter:image" content={imageMetaTags.twitter.url} />
                    </>
                )}
                <link rel="stylesheet" href="https://static.finncdn.no/_c/troika-css/v8.4.25/components/lightbox-gallery.min.css" />
                <link rel="stylesheet" href="https://static.finncdn.no/_c/troika-css/v8.4.25/components/imageformat.min.css" />
            </Head>
            <Main podlets={podlets} broadcastUrl={broadcastUrl}>
                <ObjectPage {...props} />
            </Main>
        </>
    );
};

const calculateCsrfTokenFromLoginCookie = (req) => {
    const token = process.env.FIAAS_ENVIRONMENT === 'prod' ? req.cookies?.__flt : req.cookies?.__flt_dev;

    return Base64.stringify(hmacSHA256(token, csrfKey));
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, res, query }: ServerSideProps) => {
    const commonProps = await buildCommonProps(req, res, query);
    let overrideLoginProps = {};

    // TODO find better method for testing a logged-in flow using something like mockttp to mock fhh-api
    if (process.env.MODULE_TEST === 'true') {
        overrideLoginProps = { loginId: 123456789 };
        // Don't fetch data on SSR in module tests; instead, do it client side so it is possible to mock the call
        await store.dispatch(populateProfile(123456789));
    } else {
        await store.dispatch(
            populateObjectSsr(query.finnkode, {
                userToken: res.locals?.userToken,
                uniqueVisitorId: req.cookies.USERID,
            })
        );

        if (store.getState().objectData.isPrivate) {
            const loginId = store.getState().objectData.orgId;
            await store.dispatch(populateProfile(loginId));
        }
    }

    return {
        // TODO redo this after replacing Redux with SWR for fetching data
        notFound: store.getState()?.objectData?.notFound === true,
        props: {
            ...commonProps,
            ...overrideLoginProps,
            loginCookieCsrfToken: calculateCsrfTokenFromLoginCookie(req),
        },
    };
});

Ad.propTypes = {
    podlets: PropTypes.string.isRequired,
};

// Move router into the component using it as a useRouter hook
export default withRouter(Ad);
